<template>
	<div id="container" class="container">
		<h1 id="titleheading">IPL Statistics 2008-16</h1>
    <VenuesPanel />
		<HostCountryPanel />
		<MotmPanel />
		<SeasonsPanel />
    <MatchWinnersPanel />
		<RunsSeasonWisePanel />
    <TossWinnerPanel />
    <EachRunPanel />
	</div>
</template>

<script>
import VenuesPanel from "./VenuesPanel.vue";

export default {
  name: "Container",
  components: {
    VenuesPanel,
    HostCountryPanel: () => import("./HostCountryPanel.vue"),
    MotmPanel: () => import("./MotmPanel.vue"),
    SeasonsPanel: () => import("./SeasonsPanel.vue"),
    MatchWinnersPanel: () => import("./MatchWinnersPanel.vue"),
    TossWinnerPanel: () => import("./TossWinnerPanel.vue"),
    RunsSeasonWisePanel: () => import("./RunsSeasonWisePanel.vue"),
    EachRunPanel: () => import("./EachRunPanel.vue")
  }
};
</script>

<style>
#container {
  background-color: rgb(250, 250, 250);
}

#titleheading {
  text-align: center;
  padding: 1.2em;
}
</style>
